const notes = document.getElementById('cartSpecialInstructions');
const cart = document.getElementById('cart');
const agree = document.getElementById('agree');

if (notes) {
  const initialNoteValue = notes.value;
  notes.addEventListener('change', (e) => {
    e.preventDefault();
    notes.value = initialNoteValue;
  });
}

cart.addEventListener('submit', (e) => {
  if (!agree.checked) {
    e.preventDefault();

    agree.parentElement.classList.add('error');
    agree.setCustomValidity(agree.validationMessage);
  }
  agree.classList.remove('error');
});
